export default function getResource(label, vars = []) {
    const resources = {
        instructions: `Sélectionnez jusqu’à <b>${vars[0]} échantillons gratuits</b> par commande. ${vars[1]}. Selon la disponibilité.`,
        tierText: `<b>${vars[0]} échantillons avec tout achat minimum de ${vars[1]} $</b>`,
        startTierText: 'Recevez',
        appendTierText: 'ou'
    };

    return resources[label];
}
